
export const readPInvest = (state) => {
  return state.invest.read_pinvest;
};
export const createPInvest = (state) => {
  return state.invest.create_pinvest;
};
export const deletePInvest = (state) => {
  return state.invest.delete_pinvest;
};